import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './contexts/LanguageContext';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <div className="App flex flex-col min-h-screen">
            <Helmet>
              {/* Search Engine Verification Tags */}
              <meta name="google-site-verification" content="5_olfcsCjStTdNxOvMg-u8aiOZzY97b7dAw5DyOxg1k" />
              <meta name="msvalidate.01" content="AC4FF91BF7E1FB1B0D958CDAF2EDBF8B" />
              
              {/* Fonts */}
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
              <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap" rel="stylesheet" />

              {/* Organization Schema - Enhanced for Real Estate */}
              <script type="application/ld+json">
                {JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "RealEstateAgent",
                  "@id": "https://www.pastoria-serralta.com/#organization",
                  "name": "PASTORIA SERRALTA, S.L.",
                  "alternateName": "PASTORIA SERRALTA",
                  "url": "https://www.pastoria-serralta.com/",
                  "logo": {
                    "@type": "ImageObject",
                    "url": "https://www.pastoria-serralta.com/logo_transparent.png",
                    "width": 300,
                    "height": 300
                  },
                  "image": "https://www.pastoria-serralta.com/og-image.jpg",
                  "telephone": "+34 638 28 12 01",
                  "email": "info@pastoria-serralta.com",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Cno. Son Rapiña, núm. 8 1ºA",
                    "addressLocality": "Palma",
                    "addressRegion": "Islas Baleares",
                    "postalCode": "07013",
                    "addressCountry": "ES"
                  },
                  "geo": {
                    "@type": "GeoCoordinates",
                    "latitude": 39.5696,
                    "longitude": 2.6502
                  },
                  "areaServed": {
                    "@type": "Place",
                    "name": "Islas Baleares, España"
                  },
                  "priceRange": "€€€",
                  "openingHoursSpecification": {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                    "opens": "09:00",
                    "closes": "18:00"
                  },
                  "sameAs": [],
                  "foundingDate": "2018",
                  "legalName": "PASTORIA SERRALTA, S.L.",
                  "taxID": "B16576076",
                  "description": "Promotor inmobiliario de referencia en las Islas Baleares. Viviendas de calidad para la clase media residente."
                })}
              </script>

              {/* WebSite Schema */}
              <script type="application/ld+json">
                {JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "WebSite",
                  "@id": "https://www.pastoria-serralta.com/#website",
                  "name": "PASTORIA SERRALTA",
                  "url": "https://www.pastoria-serralta.com/",
                  "publisher": {
                    "@id": "https://www.pastoria-serralta.com/#organization"
                  },
                  "inLanguage": ["es", "en"]
                })}
              </script>

              {/* LocalBusiness Schema for Enhanced Local SEO */}
              <script type="application/ld+json">
                {JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "LocalBusiness",
                  "@id": "https://www.pastoria-serralta.com/#localbusiness",
                  "name": "PASTORIA SERRALTA, S.L.",
                  "image": "https://www.pastoria-serralta.com/logo_transparent.png",
                  "telephone": "+34 638 28 12 01",
                  "email": "info@pastoria-serralta.com",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Cno. Son Rapiña, núm. 8 1ºA",
                    "addressLocality": "Palma",
                    "addressRegion": "Islas Baleares",
                    "postalCode": "07013",
                    "addressCountry": "ES"
                  },
                  "geo": {
                    "@type": "GeoCoordinates",
                    "latitude": 39.5696,
                    "longitude": 2.6502
                  },
                  "url": "https://www.pastoria-serralta.com/",
                  "priceRange": "€€€"
                })}
              </script>
            </Helmet>

            <Header />
            <CookieConsent />
            <main className="flex-grow">
              <Routes>
                {/* Spanish Routes (Default) */}
                <Route path="/" element={<Home />} />
                <Route path="/sobre-nosotros" element={<About />} />
                <Route path="/promociones" element={<Projects />} />
                <Route path="/promociones/:slug" element={<ProjectDetail />} />
                <Route path="/contacto" element={<Contact />} />
                <Route path="/aviso-legal" element={<Legal />} />
                <Route path="/privacidad" element={<Privacy />} />
                <Route path="/cookies" element={<Cookies />} />

                {/* English Routes */}
                <Route path="/en" element={<Home />} />
                <Route path="/en/about" element={<About />} />
                <Route path="/en/projects" element={<Projects />} />
                <Route path="/en/projects/:slug" element={<ProjectDetail />} />
                <Route path="/en/contact" element={<Contact />} />
                <Route path="/en/legal" element={<Legal />} />
                <Route path="/en/privacy" element={<Privacy />} />
                <Route path="/en/cookies" element={<Cookies />} />

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
